/* unplugin-vue-components disabled */import script from "./user-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./user-modal.vue?vue&type=script&setup=true&lang=js"

import "./user-modal.vue?vue&type=style&index=0&id=4a1c0346&lang=scss"

const __exports__ = script;

export default __exports__